import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Form to select the division of an isp vision api key, the key name is set by the backend
const IspVisionApiKeyForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {
    const apiObject = 'api_token'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'division',
            label: 'api_key.general.division_label',
            type: 'dropdown',
            disabled_selected: 'api_key.general.select_division_disabled_selected',
            showSearch: false,
            apiRequest: [{
                endpoint: 'get_division_list',
                object: 'division',
                params: { is_active: true },
                useCache: true
            }],
            allowNoneOption: false,
            activeFeature: 'divisions',
            helperText: 'integrations.isp_vision.division_helperText'
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            linkedItem={{ source: 'isp_vision' }}
        />
    );
};

export default IspVisionApiKeyForm;
